import request from '@/utils/request';
import type { AxiosResponse } from 'axios';

export async function getSysUsers(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/thsuaa/api/sys-users', { params: params });
}

export async function getSysUserById(id?: any) {
  return request.get<any, AxiosResponse<any>>(`/thsuaa/api/sys-users/${id}`);
}

export async function createSysUser(tenantId?:string, data?: any) {
  return request.post<any, AxiosResponse<any>>(`/thsuaa/api/sys-users/${tenantId}`, data);
}

export async function updateSysUser(tenantId?:string, data?: any) {
  return request.put<any, AxiosResponse<any>>(`/thsuaa/api/sys-users/${tenantId}`, data);
}

export async function deleteSysUser(id?: string) {
  return request.delete<any, AxiosResponse>(`/thsuaa/api/sys-users/${id}`);
}

export async function transferSuperAdmin(id?: string) {
  return request.post<any, AxiosResponse>(`/thsuaa/api/sys-users/transferSuperAdmin/${id}`);
} 

export async function getUserRoles(userId: string) {
  return request.get<any, AxiosResponse<any[]>>(`/thsuaa/api/sys-users/${userId}/roles`);
}


export async function updateUserRoles(userId: string, roleIds: string[]) {
  return request.put<any, AxiosResponse<any[]>>(`/thsuaa/api/sys-users/${userId}/roles`,  roleIds);
}



export async function getRoles(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/thsuaa/api/sys-roles', { params: params });
}


export async function createRole(data?: any) {
  return request.post<any, AxiosResponse<any>>('/thsuaa/api/sys-roles', data);
}

export async function savePermiss(roleId: string, data?: any ) {
  return request.put<any, AxiosResponse<any>>(`/thsuaa/api/sys-roles/${roleId}/permissions`, data);
}

export async function updateRole(data?: any) {
  return request.put<any, AxiosResponse<any>>('/thsuaa/api/sys-roles', data);
}


export async function getRolePermissions(params?: any) {
  return request.get<any, AxiosResponse<any[]>>('/thsuaa/api/sys-role-permissions', { params: params });
}

export async function deleteRole(id?: string) {
  return request.delete<any, AxiosResponse<any>>(`/thsuaa/api/sys-roles/${id}`);
}

export async function afterLogin() {
  return request.get<any, AxiosResponse<any>>(`/api/after-login`);
}

export async function heartbeat(id: string) {
  return request.get<any, AxiosResponse<any>>(`/api/log-heartbeat/${id}`);
}

export async function updateLog( projectId: string) {
  return request.get<any, AxiosResponse<any>>(`/api/log-change-project/${projectId}`);
}

export async function createTrackingLog( params: any) {
  return request.post<any, AxiosResponse<any>>(`/api/log-tracking/create`,  params);
}
export async function getSysUsersByConditions(params?: any) {
  return request.post<any, AxiosResponse<any[]>>('/thsuaa/api/sys-users/by-conditions', params );
}

export async function updateUserRelations(userId: string, projectIds: string[]) {
  return request.put(`/api/users/${userId}/relation`,  projectIds);
}

export async function saveUserProjectRelations(projectId: string, users: any[]) {
  return request.put(`/api/users/${projectId}/project-relation`,  users);
}


export async function getTenantListByCurrentUser() {
  return request.get(`/api/users/tenant-list`)
}